/*
 * Jira Ticket:
 * Created Date: Mon, 23rd Mar 2020, 14:27:56 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { useEffect, useState } from 'react';
import { Edit, FormTab, TabbedForm, usePermissions, Title } from 'react-admin';
import { connect } from 'react-redux';
import { ReactivateUserToolbar, SaveDeactivateToolbar } from 'Components';
import OverviewTab from './Tabs/Overview';
import EmploymentTab from './Tabs/Employment';
import InvitesTab from './Tabs/Invites';
import { isSuperAdmin, isProjectManager, isSelf } from 'utils/roles';
// import { ReactivateToolbar } from 'Components/Toolbars';

const UserEdit = props => {
  const {
    hasDelete,
    hasCreate,
    hasShow,
    hasList,
    hasEdit,
    className,
    formValues,
    dispatch,
    onSave,
    location,
    ...rest
  } = props;
  const { permissions } = usePermissions();
  const title =
    formValues && formValues[props.id]
      ? formValues[props.id].hasAccount
        ? `${formValues[props.id].givenName} ${formValues[props.id].familyName}`
        : formValues[props.id].email
      : 'resources.User.fields.userDetail';
  const [showToolbar, setShowToolbar] = useState(false);
  const [reactivateToolBar, setReactivateToolBar] = useState(false);
  const isAdmin = formValues[props.id] && formValues[props.id].isAdmin;
  const hasAccount = formValues[props.id] && formValues[props.id].hasAccount;
  const notActive =
    formValues[props.id] && formValues[props.id].status === 'inactive';
  const isSuperAdminResult = isSuperAdmin(permissions);
  const isProjectManagerResult = isProjectManager(permissions);
  const isSelfResult = isSelf(props.id);

  const isOverviewTab = currentLocation => {
    const tabNumber =
      currentLocation.split('/').length === 4
        ? currentLocation.split('/')[3]
        : '';
    if (tabNumber === '') {
      return true;
    }
    return false;
  };

  const handleReactivateUser = () => {};

  useEffect(() => {
    const checkUserPermissionsLocation = (location, permissions) => {
      if (location) {
        const currentLocation = location.pathname;
        if (notActive) {
          return setReactivateToolBar(true);
        } else {
          if (hasAccount && isOverviewTab(currentLocation)) {
            return setShowToolbar(true);
          }
        }
      }
      return setShowToolbar(false);
    };
    return checkUserPermissionsLocation(location, permissions);
  }, [location, notActive, hasAccount, permissions]);

  return (
    <>
      <Title title={`resources.General.cmsTitle`} />
      <Edit title={title} {...rest}>
        <TabbedForm
          redirect={false}
          toolbar={
            reactivateToolBar ? (
              <ReactivateUserToolbar />
            ) : showToolbar ? (
              <SaveDeactivateToolbar />
            ) : null
          }
        >
          {permissions ? (
            <FormTab label={'resources.User.fields.tab1'}>
              <OverviewTab
                {...props}
                permissions={permissions}
                isSuperAdmin={isSuperAdminResult}
              />
            </FormTab>
          ) : null}
          {!isAdmin &&
          permissions &&
          (isProjectManagerResult || isSelfResult) ? (
            <FormTab label={'resources.User.fields.tab2'}>
              <EmploymentTab {...props} permissions={permissions} />
            </FormTab>
          ) : null}
          {!isAdmin &&
          permissions &&
          (isProjectManagerResult || isSelfResult) ? (
            <FormTab label={'resources.User.fields.tab3'}>
              <InvitesTab {...props} permissions={permissions} />
            </FormTab>
          ) : null}
        </TabbedForm>
      </Edit>
    </>
  );
};

const mapStateToProps = state => ({
  formValues: state.admin.resources.User && state.admin.resources.User.data,
});

export default connect(mapStateToProps)(UserEdit);
